import color from './color.js'
import theme from './theme.js'
import gradient from './gradient.js'
import font from './font.js'
import font_family from './font_family.js'
import typography from './typography.js'
import spacing from './spacing.js'
import timing from './timing.js'
import _class from './class.js'
import grid from './grid.js'
import icons from './icons.js'
import shape from './shape.js'
import reset from './reset.js'
import animation from './animation.js'
import media from './media.js'
import cases from './cases.js'

export default {
  color: color,
  theme: theme,
  gradient: gradient,
  font: font,
  font_family: font_family,
  typography: typography,
  spacing: spacing,
  timing: timing,
  class: _class,
  grid: grid,
  icons: icons,
  shape: shape,
  reset: reset,
  animation: animation,
  media: media,
  cases: cases,
}
